export const buildAuthorizationHeaderValue = (accessToken: string): string => `Bearer ${accessToken}`;
